import logger from '../utils/logger';
import axios from 'axios';

// Configuración base de axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 segundos
  withCredentials: true, // ✅ CRÍTICO: Permite enviar cookies httpOnly automáticamente
});

// ✅ YA NO NECESITAS INTERCEPTOR DE REQUEST
// Las cookies httpOnly se envían automáticamente con withCredentials: true

// Interceptor de peticiones vacío (ya no necesitamos agregar token manualmente)
api.interceptors.request.use(
  (config) => {
    // Las cookies se envían automáticamente
    return config;
  },
  (error) => {
    logger.error('Error en interceptor de request:', error);
    return Promise.reject(error);
  }
);

// Interceptor de respuestas: Maneja errores de autenticación
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      const status = error.response.status;
      const message = error.response.data?.message || error.response.data?.error || 'Error desconocido';

      if (status === 401) {
        // Token inválido o expirado - La cookie se limpia automáticamente por el servidor
        logger.error('Sesión expirada o token inválido');

        // Solo redirigir si no estamos en una ruta pública
        const publicPaths = ['/login', '/signup'];
        const currentPath = window.location.pathname;
        
        if (!publicPaths.includes(currentPath)) {
          // Guardar la ruta intentada para redirigir después del login
          sessionStorage.setItem('redirectAfterLogin', currentPath);
          window.location.href = '/login';
        }
      } else if (status === 403) {
        // Acceso denegado (sin permisos)
        logger.error('Permisos insuficientes:', message);
        // No redirigir automáticamente, dejar que el componente maneje el error
      } else if (status === 429) {
        // Rate limit excedido
        const retryAfter = error.response.headers['retry-after'];
        logger.warn('Demasiadas peticiones. Reintentar después de:', retryAfter || '15 minutos');
      } else if (status >= 500) {
        // Error del servidor
        logger.error('Error del servidor:', message);
      } else if (status === 404) {
        // Recurso no encontrado
        logger.warn('Recurso no encontrado:', error.config.url);
      }
    } else if (error.request) {
      // La petición fue hecha pero no se recibió respuesta
      logger.error('Sin respuesta del servidor. Verifica tu conexión a internet.');
    } else {
      // Algo pasó al configurar la petición
      logger.error('Error al configurar la petición:', error.message);
    }

    return Promise.reject(error);
  }
);

// Función helper para limpiar sesión y redirigir
export const clearTokenAndRedirect = async (redirectToLogin = true) => {
  try {
    // Llamar al endpoint de logout para limpiar la cookie en el servidor
    await api.post('/logout');
  } catch (error) {
    logger.warn('Error al cerrar sesión en el servidor:', error);
  }
  
  // Limpiar datos de sesión relacionados
  sessionStorage.removeItem('redirectAfterLogin');
  
  if (redirectToLogin) {
    window.location.href = '/login';
  }
};

// Función helper para verificar conectividad (sin uso de token)
export const checkAPIHealth = async () => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/health`,
      timeout: 5000
    });
    return response.status === 200;
  } catch (error) {
    logger.error('Servidor no disponible:', error.message);
    return false;
  }
};

export default api;
